import React from 'react';
import { MultiSelect } from 'primereact/multiselect';

interface FilterProps {
    options: { label: string; value: string }[];
    selectedOptions: string[];
    onChange: (value: string[]) => void;
}

const Filter: React.FC<FilterProps> = ({ options, selectedOptions, onChange }) => {
    return (
        <div className="atlas-filter">
            <MultiSelect
                value={selectedOptions}
                options={options}
                onChange={(e) => onChange(e.value)}
                placeholder="Filter by Role"
            />
        </div>
    );
};

export default Filter;
